import { ICommentariesDataItem } from '../../types/layout/commentaries';
import { TCommentariesSetData } from '../../types/redux/commentaries';

export const COMMENTARIES_SET_DATA = 'COMMENTARIES_SET_DATA';

export const setData = (dataIndex: string, data: ICommentariesDataItem[]): TCommentariesSetData => ({
    type: COMMENTARIES_SET_DATA,
    payload: { data, dataIndex },
});
